<template>
	<div
		class="fixed top-0 z-[1000] flex h-12 w-full flex-row items-center justify-center p-4 md:h-8"
		:class="bgColor"
	>
		<p class="text-center text-base text-white">
			<span class="font-semibold">Year End Sale</span>
			- Enjoy $0 Upfront fee. *Limited time offer, available on select
			vehicles only
		</p>
	</div>
</template>

<script setup>
defineProps({
	bgColor: {
		type: String,
		default: 'bg-gradient-to-r from-blue-500 via-blue-400 to-blue-300',
		required: false,
	},
	textColor: {
		type: String,
		default: 'text-white hover:text-gray-300',
		required: false,
	},
	underlineColor: {
		type: String,
		default: 'decoration-white hover:decoration-gray-300',
		required: false,
	},
})
</script>
